import ColumnConfig, { ColumnConfigPropTypes } from './ColumnConfig';

export default ColumnConfig;
export { ColumnConfigPropTypes };
